import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export type FiltersOptions = {
  campaignId?: number;
  presentationType?: string;
};

export const useFilters = (options: FiltersOptions) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/negociant/filters',
    {
      params: {
        query: {
          campaign_id: options.campaignId,
          presentation_type: options.presentationType
        }
      }
    }
  );

  return {
    isLoadingFilters: isLoading,
    filters: {
      availablePresentations: data?.available_presentations || [],
      campaigns: data?.campaigns || [],
      negociants: data?.negociants || [],
      saleTypes: data?.sale_types || [],
      wines: data?.wines || []
    },
    refetchFilters: refetch
  };
};

export const useNegociantsSubmissions = (options: { campaignId?: number }) => {
  const enabled = options.campaignId !== null;
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/negociant/campaign/{campaign_id}/submissions-stats-by-wine',
    {
      params: {
        path: {
          // @ts-expect-error use enabled to not call without campaign
          campaign_id: options.campaignId
        }
      },
      queryOpts: {
        enabled: enabled
      }
    }
  );

  return {
    isLoadingData: isLoading,
    data: {
      campaignId: data?.campaign_id || null,
      campaignSubmissionsStats: data?.campaign_submissions_stats || []
    },
    refetchData: refetch
  };
};

export const useSubmissions = (enabled: boolean) => {
  const {
    isLoading: isLoadingSubmissions,
    data,
    refetch: refetchSubmissions
  } = useTypedQuery('get', '/negociant-data/submissions', {
    params: {},
    queryOpts: {
      enabled: enabled
    }
  });

  return {
    isLoadingSubmissions,
    submissions: data?.submissions || [],
    refetchSubmissions
  };
};
